import Vue from 'vue';
import AOS from 'aos';
import App from './App.vue';
import i18n from './i18n';
import router from './router';
import store from './store';

import LImage from './components/site/LImage.vue';

Vue.config.productionTip = false;

Vue.component('LImage', LImage);

new Vue({
  router,
  store,
  i18n,
  mounted() {
    AOS.init();
  },
  // eslint-disable-next-line id-length
  render(h) {
    return h(App);
  },
}).$mount('#app');
